import axios from '../../../utilities/axios';
import {ValidateOtpRequest} from '../../../models/requests/validateOtp.request';
import {AnswerDto} from '../../../models/dtos/answer.dto';

export const validateOtpRequest = async (request: ValidateOtpRequest): Promise<AnswerDto> => {
  try {
    const response = await axios.post<AnswerDto>(
      `${process.env.REACT_APP_BASE_URL}/answers/otp`,
      {...request},
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
